/* a.s.r. annual report 2021 Custom JS
January 2022 - SupQuest  */

$(document).ready(function() {

	// Toggle the menu if the user hovers over the item.
	$(".asr2021-menu-chapters").hover(function(){
		$('.asr2021-menu-open').show();

		// Hide other menu..
		$('.asr2021-menu-downloads').dropdown('hide');

	});

	// For mobile..
	$(".asr2021-mobile-menu").click(function(){

		$('.asr2021-menu-open').toggle();

		$('.asr2021-menu-open-items-wrapper').find('a').each(function() {

			// Only show level 2 + level 3 mobile menus when they exist..
			if(typeof $(this).attr("data-target") != 'undefined' && $(this).attr("data-target").length > 0) {

				old_href = $(this).attr('href');

				$(this).attr('old-href', old_href);
				$(this).attr('href', '#');
			
			}

		});
		
	});

	// Toggle the menu if the user hovers over the item.
	$(".asr2021-menu-open").mouseleave(function (e) {
		$('.asr2021-menu-open').hide();
	});

	// Main navigation level
	$(".asr2021-menu-open-items-wrapper").on("mouseenter", "a", function() {
		
		data_target = $(this).attr('data-target');

		// Hide old items and show the hovered item
		$('.asr2021-menu-level-2, .asr2021-menu-level-3').hide();
		$('.l2-' + data_target).show();

	});

	// Level 2 menu logic..
	$(".asr2021-menu-level-2").on("mouseenter", "a", function() {
		
		// In this case we check if the item has a data_target
		data_target = $(this).attr('data-target');
		
		if(data_target !== null && data_target !== undefined) {

			// Hide old items and show the hovered item
			$('.asr2021-menu-level-3').hide();
			$('.l3-' + data_target).show();

		}

	});


	// Show downloads menu on hover..
	$(".asr2021-menu-downloads").hover(function(){
		$('.asr2021-menu-downloads').dropdown('show');

		// Hide other menu..
		$('.asr2021-menu-open').hide();

	});

	// Hide downloads menu on mouseleave..
	$(".asr2021-downloads-menu").mouseleave(function (e) {
		$('.asr2021-menu-downloads').dropdown('hide');
	});

	
});

// When there is a normal click, open the href!
$(".asr2021-menu-open-items-wrapper > a, .asr2021-menu-level-2 > a, .asr2021-menu-level-3 > a, .asr2021-menu-mobile-items-wrapper > a").click( function(e) {
	$(location).attr('href', $(this).attr("href"));
 });

// Mobile logic for navigation
$(".asr2021-menu-open-items-wrapper").on("click", "a", function(e) {
	
	data_target = $(this).attr('data-target');

	if($('.asr2021-menu-mobile-items-wrapper').css('display') == 'none' || $('.asr2021-menu-mobile-items-wrapper').css("visibility") == "hidden") {
		
		$(location).attr('href', $(this).attr("href"));

	}

	else {

		// Hide old items and show the hovered item
		$('.asr2021-menu-open-items-wrapper').hide();
		$('.asr2021-menu-mobile-items-wrapper').html('');
		$('.asr2021-menu-mobile-items-wrapper').append($('<a href="#" class="asr2021-mobile-backbtn" data-target="back">Back</a>'))
		$('.asr2021-menu-mobile-items-wrapper').append($('<span>Read everything</span>'))
		$('.asr2021-menu-mobile-items-wrapper').append($('<a href="' + $(this).attr("old-href") + '" class="asr2021-mobile-btn asr2021-menu-mobile-no-next-item">' + $(this).text() + '</a>'))

		if(typeof $(this).attr("data-target") != 'undefined' && $(this).attr("data-target").length > 0) {

			$('.asr2021-menu-mobile-items-wrapper').append($('<span>Or read by chapter</span>'))

			$('.l2-' + data_target).each(function() {

				$('.asr2021-menu-mobile-items-wrapper').append('<div class="asr2021-mobile-levels">' + $(this).html() + '</div>');

			});

	
			// Loop to find l3 contents..
			$('.asr2021-mobile-levels').find('a').each(function() {

				l3_data_target = $(this).attr('data-target');
				l3_contents = $('.l3-' + l3_data_target).html();

				if(typeof l3_contents != 'undefined' && l3_contents.length > 0) {

					$('<div class="asr2021-mobile-l3">' + l3_contents + '</div').insertAfter($(this));

				}

			});

		}

		else {

			$(location).attr('href', $(this).attr("href"));
			
		}

	}


});

// Back to level one on mobile..
$(".asr2021-menu-mobile-items-wrapper").on("click", "a", function() {

	data_target = $(this).attr('data-target');

	if(data_target === 'back') {

		$('.asr2021-menu-mobile-items-wrapper').html('');
		$('.asr2021-menu-open-items-wrapper').show();

	}

});
